import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.map.js";
import React from 'react';
import { getProductTypeLabel } from '@finect/front-resources/Products';
import { CheckboxFilter, FiltersContainer, SortsContainer, FiltersRestore, ViewToggle } from '../../Filter';
import { NumberLabel } from '../../Labels';
import { Inner, InnerWrapper, ActiveFiltersDescription, srri } from './partials';
import { getManagementCompaniesOptions, getCategoriesOptions, getRisksOptions, getOriginsOptions, getIndexedOptions, getManagementCompanyInitialValue, getCategoryInitialValue, getRiskInitialValue, getOriginInitialValue, getIndexedInitialValue, getOrdersOptions, getOrderInitialValue } from './utils';
export var FundsScreenerFilters = function FundsScreenerFilters(_ref) {
  var view = _ref.view,
    productType = _ref.productType,
    funds = _ref.funds,
    paging = _ref.paging,
    fetching = _ref.fetching,
    managementCompany = _ref.managementCompany,
    category = _ref.category,
    risk = _ref.risk,
    origin = _ref.origin,
    indexed = _ref.indexed,
    order = _ref.order,
    managementCompanies = _ref.managementCompanies,
    categories = _ref.categories,
    origins = _ref.origins,
    indexes = _ref.indexes,
    orders = _ref.orders,
    onManagmentCompanyChange = _ref.onManagmentCompanyChange,
    onCategoryChange = _ref.onCategoryChange,
    onSRRIChange = _ref.onSRRIChange,
    onOriginChange = _ref.onOriginChange,
    onIndexedChange = _ref.onIndexedChange,
    onOrderChange = _ref.onOrderChange,
    onRestore = _ref.onRestore,
    onViewChange = _ref.onViewChange;
  var handleManagementCompanyReturn = onManagmentCompanyChange ? onManagmentCompanyChange : function () {};
  var handleCategoryReturn = onCategoryChange ? onCategoryChange : function () {};
  var handleSRRIReturn = onSRRIChange ? onSRRIChange : function () {};
  var handleOriginChange = onOriginChange ? onOriginChange : function () {};
  var handleIndexedChange = onIndexedChange ? onIndexedChange : function () {};
  var handleRestore = onRestore ? onRestore : function () {};
  var handleOrderChange = onOrderChange ? onOrderChange : function () {};
  var noActiveFilters = !managementCompany && !category && !risk && !origin;
  return React.createElement(Inner, null, React.createElement(InnerWrapper, null, React.createElement(FiltersContainer, null, React.createElement(CheckboxFilter, {
    multiple: true,
    open: false,
    search: true,
    placeholder: 'Gestora',
    options: getManagementCompaniesOptions(managementCompanies),
    onReturn: handleManagementCompanyReturn,
    initialValue: getManagementCompanyInitialValue(managementCompany)
  }), React.createElement(CheckboxFilter, {
    multiple: true,
    search: true,
    placeholder: "Categor\xEDa",
    title: "Filtra por categor\xEDa",
    options: getCategoriesOptions(categories),
    onReturn: handleCategoryReturn,
    initialValue: getCategoryInitialValue(category)
  }), React.createElement(CheckboxFilter, {
    multiple: true,
    placeholder: "Riesgo",
    title: "Riesgo",
    options: getRisksOptions(srri),
    onReturn: handleSRRIReturn,
    initialValue: getRiskInitialValue(risk)
  }), React.createElement(CheckboxFilter, {
    placeholder: "Origen",
    title: "S\xF3lo ver ".concat(getProductTypeLabel(productType, 'shortPlural', 'lowercase'), " ofrecidos por gestoras espa\xF1olas"),
    options: getOriginsOptions(origins),
    onReturn: handleOriginChange,
    initialValue: getOriginInitialValue(origin)
  }), React.createElement(CheckboxFilter, {
    placeholder: "Indexado",
    title: "S\xF3lo ver ".concat(getProductTypeLabel(productType, 'shortPlural', 'lowercase'), " indexados / no indexados"),
    options: getIndexedOptions(indexes),
    onReturn: handleIndexedChange,
    initialValue: getIndexedInitialValue(indexed)
  }), React.createElement(FiltersRestore, {
    width: "auto",
    onClick: handleRestore,
    hidden: noActiveFilters
  }, "Restablecer")), React.createElement(SortsContainer, null, React.createElement(CheckboxFilter, {
    right: true,
    placeholder: "Ordenar por",
    title: "Ordenar ".concat(getProductTypeLabel(productType, 'shortPlural', 'lowercase'), " por..."),
    options: getOrdersOptions(orders),
    onReturn: handleOrderChange,
    initialValue: getOrderInitialValue(order)
  }), React.createElement(ViewToggle, {
    view: view,
    onClick: onViewChange
  }))), React.createElement(ActiveFiltersDescription, null, fetching ? "Cargando " : React.createElement(React.Fragment, null, "Est\xE1s viendo ", funds.length || 0, " de ", React.createElement(NumberLabel, {
    value: paging.totalItems || 0,
    decimals: 0
  }), ' '), getProductTypeLabel(productType, 'shortPlural', 'lowercase'), risk && risk.length > 0 ? React.createElement(React.Fragment, null, ' ', "con riesgo", risk.length > 1 && 's', " ", risk.map(function (ri) {
    return ri.label;
  }).join(', ')) : '', origin ? React.createElement(React.Fragment, null, " de origen ", origin.name.toLowerCase()) : '', indexed ? React.createElement(React.Fragment, null, " ", indexed.name.toLowerCase()) : ''));
};
export default FundsScreenerFilters;